import { FC } from "react";
import { Checkbox } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Session } from '@models/session';
import TableCell from '@mui/material/TableCell';
import StyledLink from '@components/StyledLink/StyledLink';
import TableRow from '@mui/material/TableRow';
import { DateUtil } from '@utils/date.util';
import SentimentLabel from '@components/SentimentLabel/SentimentLabel';

export interface SessionRowProps {
  selected: boolean;
  session: Session;
  onSelect: () => void;
  onEdit: () => void;
  onRemove: () => void;
}

const SessionRow: FC<SessionRowProps> = ({
  selected,
  session,
  onSelect,
  onEdit,
}) => {
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell scope="row">
        <Checkbox checked={selected} onClick={onSelect} />
      </TableCell>
      <TableCell>
        <StyledLink to={""} onClick={onEdit}>
          {t(`sessions.types.${session.activityType}`)}
        </StyledLink>
      </TableCell>
      <TableCell>
        {DateUtil.formatDateTime(session.createdDate)}
      </TableCell>
      <TableCell>
        {session.endTime ? DateUtil.formatDuration(Date.parse(session.endTime) - Date.parse(session.createdDate)) : t('sessions.inProgress')}
      </TableCell>
      <TableCell>
        <SentimentLabel sentiment={session.sentiment} />
      </TableCell>
    </TableRow>
  );
};

export default SessionRow;
